/* Maison Lumelle — PDP interactions (gallery, variants, cart, delivery, accordions, sticky) */
(function () {
  'use strict';

  function money(cents) {
    var v = (cents / 100);
    var s = v.toFixed(2).replace('.', ',').replace(/,00$/, '');
    return s + ' €';
  }
  function frDate(d) {
    var months = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
    return 'le ' + d.getDate() + ' ' + months[d.getMonth()];
  }
  function addBusinessDays(from, n) {
    var d = new Date(from.getTime());
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) added++;
    }
    return d;
  }

  function init(root) {
    root = root || document;
    var pdp = root.querySelector('.lumelle-pdp');
    if (!pdp || pdp.__lmInit) return;
    pdp.__lmInit = true;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function q(s, el) { return (el || pdp).querySelector(s); }
    function qa(s, el) { return Array.prototype.slice.call((el || pdp).querySelectorAll(s)); }
    function guard(fn) { try { fn(); } catch (e) { if (window.console && console.warn) console.warn('[lumelle-pdp]', e); } }

    var data = {};
    var dataEl = q('.lumelle-pdp-data') || document.querySelector('.lumelle-pdp-data');
    if (dataEl) { try { data = JSON.parse(dataEl.textContent); } catch (e) { data = {}; } }
    var variants = data.variants || [];
    var optionNames = data.optionNames || [];
    var selected = {};

    // Current variant: URL ?variant= > first available > first
    var urlVariant = null;
    try { var mm = /[?&]variant=(\d+)/.exec(window.location.search); if (mm) urlVariant = parseInt(mm[1], 10); } catch (e) {}
    var currentVariant = (urlVariant && variants.filter(function (v) { return v.id === urlVariant; })[0])
      || variants.filter(function (v) { return v.available; })[0]
      || variants[0] || null;

    var qty = 1;

    var priceEl = q('.lumelle-price-cur');
    var compareEl = q('.lumelle-price-old');
    var saveEl = q('.lumelle-price-save');
    var stickyPriceEl = q('.lumelle-sticky-price');
    var stickyVarEl = q('.lumelle-var-condensed');
    var stockDot = q('.lumelle-stock-dot');
    var stockTxt = q('.lumelle-stock-txt');
    var atcLabel = q('.lumelle-atc-label');
    var slides = qa('.lumelle-gal-slide');
    var thumbs = qa('.lumelle-thumb');

    function showSlide(i) {
      slides.forEach(function (s) { s.style.opacity = (s.getAttribute('data-slide') === String(i)) ? '1' : '0'; });
      thumbs.forEach(function (t) {
        var on = t.getAttribute('data-slide') === String(i);
        t.style.borderColor = on ? '#A98B4F' : '#E5DED2';
        t.style.opacity = on ? '1' : '0.65';
      });
    }
    function applyVariant() {
      if (!currentVariant) return;
      if (priceEl) priceEl.innerHTML = money(currentVariant.price);
      if (compareEl) {
        if (currentVariant.compare_at && currentVariant.compare_at > currentVariant.price) {
          compareEl.innerHTML = money(currentVariant.compare_at); compareEl.style.display = '';
          if (saveEl) {
            var pct = Math.round((currentVariant.compare_at - currentVariant.price) * 100 / currentVariant.compare_at);
            saveEl.innerHTML = '— ' + pct + ' %'; saveEl.style.display = '';
          }
        } else {
          compareEl.style.display = 'none'; if (saveEl) saveEl.style.display = 'none';
        }
      }
      if (stickyPriceEl) stickyPriceEl.innerHTML = money(currentVariant.price);
      if (stickyVarEl) stickyVarEl.textContent = currentVariant.title;
      if (currentVariant.featured_media != null) showSlide(currentVariant.featured_media);
      var avail = currentVariant.available;
      if (stockDot) stockDot.style.background = avail ? '#4A7C59' : '#B0483C';
      if (stockTxt) stockTxt.textContent = avail ? 'En stock — expédiée sous 1 à 2 jours ouvrés' : 'Bientôt de retour';
      if (atcLabel) atcLabel.textContent = avail ? 'Ajouter au panier' : 'Indisponible';
    }
    function resolveVariant() {
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) {
          var nm = optionNames[i];
          return selected[nm] == null || selected[nm] === o;
        });
      })[0];
      if (match) currentVariant = match;
      guard(applyVariant);
    }

    // ---- ADD TO CART — bound FIRST, via delegation, so nothing downstream can block it ----
    function addToCart(btn) {
      if (!currentVariant) currentVariant = variants.filter(function (v) { return v.available; })[0] || variants[0];
      if (!currentVariant || !currentVariant.available) return;
      var sweep = btn.querySelector('.lumelle-atc-sweep');
      var label = btn.querySelector('.lumelle-atc-label') || btn;
      if (sweep && !reduced) sweep.style.transform = 'scaleX(1)';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: currentVariant.id, quantity: qty })
      }).then(function (r) { return r.json(); }).then(function () {
        return fetch('/cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        var prev = label.textContent;
        label.textContent = 'Ajouté ✓';
        qa('.lumelle-cart-count, [data-cart-count]').forEach(function (c) { c.textContent = ' (' + cart.item_count + ')'; });
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if (window.LumelleCart && window.LumelleCart.refresh) { try { window.LumelleCart.refresh(true); } catch (e) {} }
        setTimeout(function () { label.textContent = prev; if (sweep) sweep.style.transform = 'scaleX(0)'; }, 1700);
      }).catch(function () { if (sweep) sweep.style.transform = 'scaleX(0)'; });
    }
    pdp.addEventListener('click', function (e) {
      var b = e.target.closest ? e.target.closest('.lumelle-atc, .lumelle-atc-mini') : null;
      if (b) { e.preventDefault(); addToCart(b); }
    });

    guard(applyVariant);

    // quantity
    guard(function () {
      var qtyVal = q('.lumelle-qty-val');
      var minus = q('.lumelle-qty-minus');
      var plusB = q('.lumelle-qty-plus');
      if (minus) minus.addEventListener('click', function () { qty = Math.max(1, qty - 1); if (qtyVal) qtyVal.textContent = qty; });
      if (plusB) plusB.addEventListener('click', function () { qty = qty + 1; if (qtyVal) qtyVal.textContent = qty; });
    });

    // gallery thumbnails
    guard(function () {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showSlide(parseInt(t.getAttribute('data-slide'), 10)); });
      });
    });

    // variant dropdowns
    guard(function () {
      qa('.lumelle-vd').forEach(function (vd) {
        var name = vd.getAttribute('data-opt');
        var cur = vd.querySelector('.lumelle-vd-cur');
        if (cur) selected[name] = cur.getAttribute('data-value') || cur.textContent.trim();
        var btn = vd.querySelector('.lumelle-vd-btn');
        var menu = vd.querySelector('.lumelle-vd-menu');
        var plus = vd.querySelector('.lumelle-vd-plus');
        if (!btn || !menu) return;
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var open = menu.style.display === 'block';
          qa('.lumelle-vd-menu').forEach(function (m) { m.style.display = 'none'; });
          qa('.lumelle-vd-plus').forEach(function (p) { p.style.transform = 'rotate(0deg)'; });
          if (!open) { menu.style.display = 'block'; if (plus) plus.style.transform = 'rotate(45deg)'; }
        });
        qa('button[data-val]', menu).forEach(function (opt) {
          opt.addEventListener('click', function () {
            selected[name] = opt.getAttribute('data-val');
            if (cur) { cur.textContent = opt.textContent.trim(); cur.setAttribute('data-value', selected[name]); }
            menu.style.display = 'none';
            if (plus) plus.style.transform = 'rotate(0deg)';
            resolveVariant();
          });
        });
      });
      document.addEventListener('click', function () {
        qa('.lumelle-vd-menu').forEach(function (m) { m.style.display = 'none'; });
        qa('.lumelle-vd-plus').forEach(function (p) { p.style.transform = 'rotate(0deg)'; });
      });
    });

    // delivery estimate
    guard(function () {
      var delEl = q('.lumelle-del-range');
      if (delEl) {
        var now = new Date();
        delEl.textContent = 'entre ' + frDate(addBusinessDays(now, 6)) + ' et ' + frDate(addBusinessDays(now, 10));
      }
    });

    // accordions
    guard(function () {
      qa('.lumelle-acc').forEach(function (acc) {
        var btn = acc.querySelector('.lumelle-acc-btn');
        var body = acc.querySelector('.lumelle-acc-body');
        var plus = acc.querySelector('.lumelle-acc-plus');
        if (!btn || !body) return;
        btn.addEventListener('click', function () {
          var open = body.style.maxHeight && body.style.maxHeight !== '0px';
          if (open) { body.style.maxHeight = '0px'; if (plus) plus.style.transform = 'rotate(0deg)'; }
          else { body.style.maxHeight = body.scrollHeight + 'px'; if (plus) plus.style.transform = 'rotate(45deg)'; }
        });
      });
    });

    // sticky buy bar
    guard(function () {
      var sticky = q('.lumelle-stickybar');
      var atcMain = q('.lumelle-atc');
      if (sticky && atcMain) {
        var onScroll = function () {
          var r = atcMain.getBoundingClientRect();
          sticky.style.transform = (r.bottom < 0) ? 'translateY(0)' : 'translateY(-110%)';
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll();
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else { init(); }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
